export default "assets/images/icons/sound-close-f7e75ce9.svg";